module.exports = __webpack_public_path__ + "img/SAS_Standard Sword.4c42b2aa.png";